import React from 'react';
import { useTranslation } from '../../../../../../i18n/use-translation';
import { Button } from '../../../../../atoms/button';
import { Image } from '../../../../../atoms/image';
import { Color } from '../../../../../enums/color';
import { Size } from '../../../../../enums/size';
import * as styles from '../../registr_form.module.sass';
import { CompleteForm } from '../CompleteForm/CompleteForm';
import { useViewModel } from './hook/use-view-model';
import { CompleteBlockProps } from './type/props';

export const RegistrationCompleteBlock = (props: CompleteBlockProps) => {
  const { t } = useTranslation();
  const { canResend, resendTimer } = useViewModel();
  // @todo: add timer
  // @todo: add resend logic
  // @todo: add complete register logic
  return (
    <div>
      <Image
        srcs={[
          {
            src: '/public-assets/img/modal/resend.svg',
            type: 'image/svg',
          },
        ]}
        src="/public-assets/img/modal/resend.svg"
        alt={t('congratulation')}
        pictureClassName={styles.resend_img}
        className={styles.resend_img}
      />
      <h3 className={styles.resend_title}>{t('congratulation')}</h3>
      <div className={styles.resend_description}>
        <span>{t('register.sms.sent')}</span>
        <CompleteForm phone={props.phone} />
      </div>
      {canResend ? <Button text={t('resend_sms')} size={Size.BIG} color={Color.SECONDARY} /> : resendTimer}
    </div>
  );
};
